import { render, staticRenderFns } from "./UITrExpand.vue?vue&type=template&id=6ff05c35"
import script from "./UITrExpand.vue?vue&type=script&lang=js"
export * from "./UITrExpand.vue?vue&type=script&lang=js"
import style0 from "./UITrExpand.vue?vue&type=style&index=0&id=6ff05c35&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports